module.exports = __webpack_public_path__ + "static/media/docker.2e0fcd7b.svg";